<!-- #################################################################################### -->
<!-- ###### HERINCO                                                                ###### -->
<!-- ###### @author: Alejandro Orozco Marulanda                                    ###### -->
<!-- ###### @date: Julio 2024                                                      ###### -->
<!-- #################################################################################### -->

<!-- #################################################################################### -->
<!-- ###### Sección de HTML                                                        ###### -->
<!-- #################################################################################### -->
<template>
  <div class="contenido">

    <!--Alert de elemento exitoso-->
    <v-snackbar v-model="alertValue" :color="alertResultado ? 'success' : 'error'" timeout="2000" top>
      {{ alertResultado? "Registro creado correctamente" : "Error" }}
    </v-snackbar>
    <!-- Filtros para buscar item -->
    <section class="d-flex">
      <!-- Filtrar por el nombre de un item -->
      <v-text-field class="me-2 filtro" v-model="buscarNombre" label="Nombre" outlined dense hide-details color="primary"
      >
      </v-text-field>

      <!-- Este botón abre un diálogo para agregar un nuevo Item -->
      <div v-if="!sincEnterprise.some(x => x === enterprise.code)">
        <v-tooltip left color="success" :open-on-focus="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab small color="success" v-on="on" v-bind="attrs"
              @mousedown.prevent="dialogoCrearItem = true">
              <v-icon>add</v-icon> 
            </v-btn>
          </template>
          <span>Agregar</span>
        </v-tooltip>
      </div>
    </section>

    <!-- Diálogo para crear una Item -->
    <v-dialog v-model="dialogoCrearItem" transition="dialog-bottom-transition" max-width="30rem" persistent>
      <v-card>
        <v-card-title class="encabezado">
          <span class="text-h6"> {{ tituloDialogo }} </span>
        </v-card-title>
        <v-card-text class="pt-5">
          <!-- Formulario para registrar una Item -->
          <v-form ref="itemForm">
            <div class="d-flex">
              <!-- Campo para el nombre -->
              <v-text-field class="me-2 filtro" v-model="crearItem.nombre" label="Nombre" dense outlined
              :rules="rules.required">
              </v-text-field>
            </div>
            <!-- Botones del formulario -->
            <div class="d-flex justify-end">
              <v-btn class="me-2" text color="error" @click="clear()">Cerrar</v-btn>
              <v-btn :color="formValid ? 'success' : 'grey'" :disabled="!formValid" depressed
                @click="!editar ? agregarItem() : editarItem()"> Guardar
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Tabla de items -->
    <v-data-table class="elevation mt-4" :items="tabla.items" :loading="tabla.loading" height="64vh"
      fixed-header :headers="tabla.headers" :footer-props="tabla.footerProps" :server-items-length="tabla.totalPage"
      :items-per-page="tabla.itemsPerPage" :page="tabla.page" items-per-page-text="Items por página"
      @update:items-per-page="(i) => tabla.itemsPerPage = i" @update:page="(p) => tabla.page = p">

    <template v-slot:[`item.estado`]="{ item }">
      <v-icon :color="!item.eliminado ? 'success' : 'error'">
        {{ !item.eliminado ? 'check_circle' : 'cancel' }}
      </v-icon>
        {{ !item.eliminado ? 'Activo' : 'Inactivo' }}
    </template>

    <template v-slot:[`item.acciones`]="{ item }" >
      <v-tooltip v-if="!sincEnterprise.some(x => x === enterprise.code)" bottom :color="!item.eliminado ? 'orange' : 'grey'">
        <template v-slot:activator="{ on, attrs}">
          <v-btn icon v-on="on" v-bind="attrs" :color="!item.eliminado ? 'orange' : 'grey'"
            text @click="!item.eliminado && abrirDialogoEditar(item)">
            <v-icon>border_color</v-icon>
          </v-btn>
        </template>
        <span>{{ !item.eliminado ? 'Editar' : `${nombreItem} inactivo` }}</span>
      </v-tooltip>

      <v-tooltip v-if="!sincEnterprise.some(x => x === enterprise.code)" bottom :color="!item.eliminado ? 'error' : 'success'">
        <template v-slot:activator="{ on, attrs}">
          <v-btn icon class="ms-2 me-2" v-on="on" v-bind="attrs" @click="abrirDialogoEstado(item)">
            <v-icon :color="!item.eliminado ? 'error' : 'success'">{{ !item.eliminado ? 'person_add_disabled' : 'how_to_reg'}}</v-icon>
          </v-btn>
        </template>
        <span>{{ !item.eliminado ? 'Inactivar' : 'Activar' }}</span>
      </v-tooltip>
    </template>

    <template v-slot:[`footer.page-text`]="items">
      {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
    </template>
    </v-data-table>

    <!-- dialogo para cambiar el estado -->
    <v-dialog v-model="dialogoCambiarEstado" transition="dialog-bottom-transition" max-width="23rem" persistent >
      <v-card>
        <v-card-title class="encabezado">
          <span class="text-h6"> {{ estado }} </span>
        </v-card-title>
        <v-card-text class="pt-5">
          <div class="d-flex justify-end">
            <v-btn class="me-2" color="error" text @click="dialogoCambiarEstado = false">No</v-btn>
            <v-btn color="success" depressed @click="editarItem()">Si</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>
<!-- #################################################################################### -->
<!-- ###### Sección de Script                                                      ###### -->
<!-- #################################################################################### -->
<script>
import { mapMutations, mapState } from "vuex";
import { Role } from "../../router/role.js";

export default {
  name: "TablaStructure",
  props: {
    ruta: {
      type: String,
      required: true
    },
    sincEnterprise:{
      type: Array,
      required: true
    },
    nombreItem:{
      type: String,
      required: true
    },
    nombreId:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      buscarNombre: "",
      dialogoCrearItem: false,
      crearItem: {
        nombre: "",
        codigoStone: "",
      },
      lastmodifiedby: "",
      tabla: {
        loading: false,
        items: [],
        headers: [
          { text: "CÓDIGO", width: "10%", sortable: false, align: "center", value: "codStone"},
          { text: "NOMBRE", width: "30%", sortable: false, align: "left", value: "nombre" },
          { text: "ESTADO", width: "30%", sortable: false, align: "center", value: "estado" },
        ],
        footerProps: {
          'items-per-page-options': [10, 20, 30, 40],
          'items-per-page-text': 'Items por página:',
          'show-current-page': true,
          'show-first-last-page': true
        },
        itemsPerPage: 10,
        page: 1,
        totalPage: 0,
      },
      tituloDialogo: "Agregar",
      userRoles: {},
      roles: Role,
      rules: {
        required: [(v) => !!v || "Este campo es requerido."],
      },
      dialogoCambiarEstado: false,
      editar:false,
      alertValue: false,
      alertResultado:false,
    };
  },
  created() {
    this.userRoles = this.auth.roles;
  },
  computed: {
    ...mapState(["auth", "notify", "busy", "enterprise"]),
    formValid() {
      const { nombre } = this.crearItem;
      return nombre.trim() !== "";
    },
    estado() {
      return !this.crearItem.eliminado
        ? `¿Desea activar ${this.nombreItem}?`
        : `¿Desea inactivar ${this.nombreItem}?`;
    },
  },
  watch: {
    // Escucha los cambios en la página actual de la tabla de items.
    // Si cambia, llama a la función para listar las items.
    "tabla.page": function () {
      this.listarItems();
    },
    // Escucha cambios en la cantidad de ítems por página en la tabla de items.
    // Si cambia, reinicia la página actual a 1 y lista los items.
    "tabla.itemsPerPage": function () {
      this.tabla.page = 1;
      this.listarItems();
    },
    // Escucha cambios en los filtros de búsqueda.
    // Si el criterio de búsqueda cambia, reinicia la página actual a 1.
    buscarNombre: function () {
      this.tabla.page = 1;
      this.listarItems();
    },
  },
  methods: {
    ...mapMutations([
      "updateAuth",
      "hideNotify",
      "showSuccess",
      "showBusy",
      "hideBusy",
    ]),
    /**
     * Método que obtiene y lista los items de la base de datos utilizando criterios de paginación y filtrado.
     * La respuesta obtenida se utiliza para actualizar la tabla de items en el frontend,
     * asignando la lista de items a 'tabla.items' y la cantidad total de items a 'tabla.totalPage'.
     */
    listarItems() {
      this.tabla.loading = true;
      this.$http
        .get(`${this.ruta}/listar`, {
          params: {
            page: this.tabla.page - 1,
            size: this.tabla.itemsPerPage,
            nombre: `${this.buscarNombre.toLowerCase()}`,
            idEmpresa: this.enterprise.code,
          },
        })
        .then((response) => {
          this.tabla.items = response.data.content;
          this.tabla.totalPage = response.data.totalElements;
          this.tabla.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.tabla.loading = false;
        });
    },
    //Función para editar un Ítem
    editarItem() {
        const item = {
          [this.nombreId]: this.crearItem[this.nombreId],
          empresa: {idEmpresa:this.enterprise.code},
          nombre: this.crearItem.nombre.toUpperCase(),
          codStone: this.crearItem.codStone,
          eliminado: this.crearItem.eliminado,
          lastmodifiedby: this.usuario
        }
        this.$http.post(`${this.ruta}/guardar`, item)
          .then(() => {
            this.listarItems();
            this.dialogoCrearItem = false;
            this.clear();
          }).catch((error) => {
            console.log(error);
          });
      },

    //Función para agregar un Item
    async agregarItem() {

      let codigo;

      try{
        codigo = await this.generarCodigoStone()
        if(typeof codigo != "number" && codigo <1){
          throw new Error("No se puedo generar codStone")
        } 
      }catch (error) {
        console.error(error);
      }

      const item = {
        nombre: this.crearItem.nombre.toUpperCase(),
        codStone: codigo,
        empresa: {
          idEmpresa: this.enterprise.code,
          },
        createdby:this.usuario,
        };
      
      this.$http
        .post(`${this.ruta}/guardar`, item)
        .then(() => {
          if(codigo>0){
            this.listarItems();
            this.dialogoCrearItem = false;
            this.clear();
            this.alertResultado=true;
            this.alertValue=true;
          }else{throw new Error("No se pudo definir codigo");} 
        })
        .catch((error) => {
          this.alertResultado=false;
          this.alertValue=true;
          console.log(error);
        });
    },
    abrirDialogoEditar(item) {
      this.tituloDialogo = "Editar";
      this.editar = true;
      this.dialogoCrearItem = true;
      this.crearItem = {
        ...item,
      };
    },
    abrirDialogoEstado(item) {
      this.crearItem = {
        ...item,
        eliminado: item.eliminado ? false : true,
      };
      this.dialogoCambiarEstado = true;
    },

    async generarCodigoStone(){
      return this.$http
        .get(`${this.ruta}/max-cod-stone`, {
          params: {
            idEmpresa:this.enterprise.code,
          },
        })
        .then((response) => {
          return response.data > 0 ? response.data + 1 : 1;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    limpiarFormulario() {
      this.crearItem.nombre = "";
    },
    /**
     * Método que se encarga de limpiar o restablecer varios valores a su estado inicial.
     */
    clear() {
      this.dialogoCrearItem = false;
      this.crearItem.nombre = "";
      this.crearItem.codStone = "";
      this.botonDisabled = false;
      this.dialogoCambiarEstado = false;
      this.tituloDialogo = "Agregar"
      this.editar = false;
      if (this.$refs.itemForm) {
          this.$refs.itemForm.resetValidation();
        }      
    },
  },
  mounted() {
    this.listarItems();
    this.lastmodifiedby = this.auth.username.toUpperCase();
    this.usuario = this.auth.username.toUpperCase();
    if(!this.sincEnterprise.some(x => x === this.enterprise.code)){
      this.tabla.headers.push({ text: "ACCIONES", width: "30%", sortable: false, align: "center", value: "acciones"})
    }
  },
};
</script>
<!-- #################################################################################### -->
<!-- ###### Sección de Style                                                       ###### -->
<!-- #################################################################################### -->
<style scoped>
.contenido {
  padding: 1rem;
  height: 86vh;
}

.encabezado {
  background-color: #1867c0;
  color: white;
}

::v-deep .elevation div table thead tr th {
  background-color: rgb(223, 223, 223) !important;
}

::v-deep .elevation div table thead tr th span {
  font-weight: bold;
  color: black !important;
}
</style>